import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default async ({ entityId, input }) => {
	const query = gql`
		mutation updateCompany($id: String!, $input: updateCompanyInput!) {
			updateCompany(id: $id, updateCompanyInput: $input) {
				status
				errors
			}
		}
	`
	const variables = {
		id: entityId,
		input
	}

	const res = await api({ query, variables })

	return Promise.resolve(res)
}
